import React from "react";
import {
  Paper,
  Grid,
  makeStyles,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from "@material-ui/core";
import "./App.css";
import PlainList from "./List";
import MaterialList from "./MaterialList";
import CheckIcon from "@material-ui/icons/Check";
import CodeSnippet from "./CodeSnippet";
import GitHubIcon from "@material-ui/icons/GitHub";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import Stackblitz from "./Stackblitz";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#f5f5f5",
    padding: theme.spacing(2)
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary
  },
  paperCenter: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.primary
  },
  inline: {
    display: "block"
  },
  addTripButton: { position: "fixed", right: "15px", bottom: "15px" }
}));

function App() {
  const classes = useStyles();

  const actions = [
    {
      icon: <LinkedInIcon />,
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/sumedh-chakravorty"
    },
    {
      icon: <GitHubIcon />,
      name: "Github",
      url: "https://github.com/sumedh22"
    },
    {
      icon: <i className="mediumIcon"></i>,
      name: "Medium",
      url: "https://medium.com/@sumedhchaccravorty"
    }
  ];
  
  const b = text => <b>{text}</b>;
  const i = text => <i>{text}</i>;
  const bi = text => (
    <b>
      <i>{text}</i>
    </b>
  );
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = action => {
    if (action.url) {
      window.open(action.url);
    }

    setOpen(false);
  };
  const stackblitzes = [
    {
      title: "Example 1: Making Rest calls to fetch data",
      steps:[
        `install npm module react-hook-pagination`,
        `import useLoadMoreOnScroll hook`,
        `Initialise the hook with fetchSize, scroller, and limit, scroller is mandatory`,
        `Create an effect when start and end changes, call your api in the effect callback`
      ],
      url:
        "https://stackblitz.com/edit/react-hook-pagination?ctl=1&embed=1&file=Hello.js&hideExplorer=1&view=preview"
    }
  ];
  return (
    <div className={classes.root}>
      <SpeedDial
        ariaLabel="SpeedDial tooltip example"
        className={classes.addTripButton}
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        color="secondary"
      >
        {actions.map(action => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            tooltipOpen
            onClick={e => handleClose(action)}
          ></SpeedDialAction>
        ))}
      </SpeedDial>
      <Grid container spacing={2}>
        <Grid container item xs={12} md={12} spacing={2}>
          <Grid item xs={12} md={12}>
            <Paper className={classes.paperCenter}>
              <Typography gutterBottom variant="h2" color="textPrimary">
                React Pagination
              </Typography>
              <Typography variant="h5" color="textPrimary">
                Implement load more on scroll using easy to use hooks! 🎉🎉
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper className={classes.paper}>
              <Typography variant="h4" color="textPrimary">
                Features
              </Typography>
              <List>
                <ListItem key={0}>
                  <ListItemIcon>
                    <CheckIcon />
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{ color: "textPrimary" }}
                    primary="Easy to use hook API, hook your list/table to a scroll element
                      and wait for the hook to tell you when to fetch next batch of data!"
                  ></ListItemText>
                </ListItem>
                <ListItem key={1}>
                  <ListItemIcon>
                    <CheckIcon />
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{ color: "textPrimary" }}
                    primary="Initial fetch till scroll appears"
                  ></ListItemText>
                </ListItem>

                <ListItem key={2}>
                  <ListItemIcon>
                    <CheckIcon />
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{ color: "textPrimary" }}
                    primary="Customise load behaviour via parameters (fetchSize, limit etc)"
                    secondary={
                      <Typography
                        component="span"
                        variant="body2"
                        color="textSecondary"
                        className={classes.inline}
                      >
                        Specify fetch size, limit and scroller to monitor fetch
                        behaviour.
                      </Typography>
                    }
                  ></ListItemText>
                </ListItem>
                <ListItem key={3}>
                  <ListItemIcon>
                    <CheckIcon />
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{ color: "textPrimary" }}
                    primary="Configure custom loader, end of list behavior"
                    secondary={
                      <Typography
                        component="span"
                        variant="body2"
                        color="textSecondary"
                        className={classes.inline}
                      >
                        Add Custom loader to notify loading progress
                      </Typography>
                    }
                  ></ListItemText>
                </ListItem>
                <ListItem key={4}>
                  <ListItemIcon>
                    <CheckIcon />
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{ color: "textPrimary" }}
                    primary="Externalized fetch, you define how to fetch, hook decides when to fetch"
                    secondary={
                      <Typography
                        component="span"
                        variant="body2"
                        color="textSecondary"
                        className={classes.inline}
                      ></Typography>
                    }
                  ></ListItemText>
                </ListItem>
              </List>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <CodeSnippet
              title="Installation"
              text="npm install react-hook-pagination"
            ></CodeSnippet>
            <CodeSnippet
              title="Import"
              text="import useLoadMoreOnScroll from 'react-hook-pagination';"
            ></CodeSnippet>
          </Grid>
        </Grid>
        <Grid item xs={12} md={4}>
          <CodeSnippet
            title="Stub"
            text={`
  const {
         start,
         end,
         isFetching,
         doneFetching,
         setIsFetching,
         forceDonefetching
       } = useLoadMoreOnScroll({ fetchSize, scroller: ulElement, limit });
                      
  useEffect(()=>{
   // Notify the hook that you are about to fetch
   setIsFetching(true);
   //fetch data when start and end changes
   fetch(start, end).then(res=>{
    if(!res.body.hasMore){
      //Stop fetching, else the hook will keep 
      //update start and end to let you fetch more data till limit is exceeded
      forceDonefetching();
    }
    // Notify the hook that you are done fetching data
    setIsFetching(false);
    });
  },[start, end])
  `}
          ></CodeSnippet>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper className={classes.paper}>
            <Typography variant="h4" color="textPrimary">
              Vanilla HTML
            </Typography>
            <PlainList></PlainList>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper className={classes.paper}>
            <Typography variant="h4" color="textPrimary">
              Material List
            </Typography>
            <MaterialList></MaterialList>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Stackblitz data={stackblitzes}></Stackblitz>
        </Grid>
        <Grid item xs={12} md={12}>
          <Paper className={classes.paper}>
            <Typography variant="h4" color="textPrimary">
              Documentation
            </Typography>
            <Typography variant="h5" color="textPrimary">
              Behaviour
            </Typography>
            <Typography variant="subtitle1" color="textPrimary">
              The hook i.e.{bi(" useLoadMoreOnScroll ")}
              will let your component know when a new chunk of data {i(
                "needs"
              )}{" "}
              to be fetched. The need to fetch new data is derived from the
              below logic:
              <ul>
                <p>
                  In the {i("normal")} load more on scroll behaviour, data is
                  fetched propressively when the user scroll towards the bottom
                  of the list. As the minimum threshold is approached. The
                  minimum threshold is set to 25 pixels by default and can be
                  altered by setting the {i("minDelta")} prop. The hook updates
                  the start and end parameters as soon as the threshold is met
                  to notifiy the component to fetch next chunk of data.
                </p>
                <p>
                  {bi(" fetchSize ")} determines the chunk size and{" "}
                  {bi(" limit ")} determines the max number of chunks the hook
                  will request the component.
                  <br></br> {i("Example")}: if your fetch size is 10 and your
                  limit is set to 500, the hook will update the start and end
                  parameters with values like (0,10), (10,20)...(490, 500).
                </p>
                <p>
                  If a scroll is not available/visible on the {bi(" scroller ")}{" "}
                  element provided, the hook will continue updating the start
                  and end variables until the scroll is made available. After
                  that, the normal load more on scroll behaviour will be
                  restored.
                </p>
                <p>
                  The hook will keep on updating the {bi(" start ")} and{" "}
                  {bi(" end ")} variables until limit is breached or{" "}
                  {bi(" forceDonefetching ")} is called externally by the
                  component.
                </p>
              </ul>
            </Typography>
            <Typography variant="h5" color="textPrimary">
              API
            </Typography>
            <Typography variant="h6" color="textPrimary">
              Hook Input
            </Typography>
            <ul>
              <p>
                {b("fetchSize ")} {i("{Number, 10}")} Determines the chunk size
                during each fetch
              </p>
              <p>
                {b("scroller ")} {i("{DOM Element}")} A react {i("Ref")}{" "}
                representing the list scroll container. Progressive fetching
                will be done based on the scroll position of this container.
              </p>
              <p>
                {b("limit ")} {i("{Number, 500}")} Max. items to display in the
                list
              </p>
              <p>
                {b("mode ")} {i("{String, 'error'}")} Set to {i("debug")} to see
                the hook logs
              </p>
              <p>
                {b("minDelta ")} {i("{Number, 25}")} The threshold gap (in
                pixels) between the container bottom and scroll position which
                will trigger the next fetch
              </p>
            </ul>
            <Typography variant="h6" color="textPrimary">
              Hook Output
            </Typography>
            <ul>
              <p>
                {b("start")} {i("{Number}")} Start index or offset for the new
                chunk
              </p>
              <p>
                {b("end")} {i("{Number}")} End index or max. items in each chunk
              </p>
              <p>
                {b("isFetching")} {i("{Boolean}")} Status to denote the fetch
                status
              </p>
              <p>
                {b("doneFetching")} {i("{Boolean}")} Either reached the{" "}
                {i("limit")} or component has called {i("forceDonefetching")}
              </p>
              <p>
                {b("setIsFetching")} {i("{Function}")} Externally set the fetch
                status when fetching data.
              </p>
              <p>
                {b("forceDonefetching")} {i("{Function}")} Terminate future
                fetches
              </p>
            </ul>
          </Paper>
        </Grid>
       
      </Grid>
    </div>
  );
}

export default App;
